(() => {
  const main = document.querySelector('#MainContent.ak-mobile-home');
  if (!main) return;
  const media = matchMedia('(max-width: 749px)');
  let marker;
  let productSection;
  const syncOrder = () => {
    if (!main.hasAttribute('data-ak-products-first')) return;
    const current = main.querySelector('.ak-home-products')?.closest('.shopify-section');
    const banner = main.querySelector('ak-banner')?.closest('.shopify-section');
    if (!current || !banner || current.parentElement !== main || banner.parentElement !== main) return;
    if (current !== productSection) {
      marker?.remove();
      productSection = current;
      marker = document.createElement('template');
      productSection.before(marker);
    }
    if (media.matches) {
      if (banner.nextElementSibling !== productSection) banner.after(productSection);
    } else if (marker?.isConnected && marker.nextElementSibling !== productSection) {
      marker.after(productSection);
    }
  };
  const guidePositions=new Map();
  const syncGuides=()=>{
    guidePositions.forEach((parts,guide)=>{
      if(!guide.isConnected){parts.forEach(part=>part.marker.remove());guidePositions.delete(guide);}
    });
    main.querySelectorAll('ak-size-guide').forEach(guide=>{
      let parts=guidePositions.get(guide);
      if(!parts){
        const copy=guide.querySelector('.akp-copy');
        if(!copy||!guide.querySelector('.akp-board'))return;
        parts=[...copy.querySelectorAll(':scope > .akp-calculator,:scope > [data-ak-help]')].map(element=>{
          const marker=document.createElement('template');element.before(marker);return {element,marker};
        });
        guidePositions.set(guide,parts);
      }
      parts.forEach(({element,marker})=>{
        if(media.matches){if(element.parentElement!==guide)guide.append(element);}
        else if(marker.isConnected&&marker.nextElementSibling!==element)marker.after(element);
      });
    });
  };
  media.addEventListener('change',syncGuides);
  document.addEventListener('shopify:section:load',syncGuides);
  syncGuides();
  media.addEventListener('change', syncOrder);
  document.addEventListener('shopify:section:load', syncOrder);
  document.addEventListener('shopify:section:reorder', () => {
    if (!media.matches && productSection?.isConnected) productSection.before(marker);
    syncOrder();
  });
  main.addEventListener('click', event => {
    const button = event.target.closest('[data-ak-products-more]');
    if (!button) return;
    const section = button.closest('.ak-home-products');
    const limit = Number(section.dataset.akLimit);
    section.setAttribute('data-ak-expanded', '');
    button.setAttribute('aria-expanded', 'true');
    const nextCard = section.querySelectorAll('.ak-product-grid > li')[limit];
    const nextLink = [...(nextCard?.querySelectorAll('.card__heading a') || [])].find(link => link.getClientRects().length && getComputedStyle(link).visibility !== 'hidden');
    nextLink?.focus({preventScroll: true});
  });
  syncOrder();
  main.setAttribute('data-ak-mobile-ready', '');
})();

